angular
	.module 'App.Service'
	.factory 'FormDataObject', () ->
		(obj) ->
			fd = new FormData()
			for own key of obj
				if obj[key] != null
					if typeof obj[key] == 'object' && !(obj[key] instanceof File)
						fd.append key, JSON.stringify obj[key]
					else
						fd.append key, obj[key]
				else
					fd.append key, '' # Use empty string as null value
			return fd
